import type { ProgrammaticLandingPageConfig } from '../../types'
import { KWP_SIZE_FACTS } from '../kwpSizeFacts'

const FACTS = KWP_SIZE_FACTS[15]

export const KWP_15_INSTALACJA_FOTOWOLTAICZNA: ProgrammaticLandingPageConfig = {
  slug: 'instalacja-fotowoltaiczna-15-kwp-cena',
  lang: 'pl',
  topicId: 'kwp-kosten-15',
  title: 'Instalacja fotowoltaiczna 15 kWp: cena i wartości orientacyjne',
  metaDescription:
    'Ile kosztuje instalacja fotowoltaiczna 15 kWp? Powierzchnia dachu, liczba paneli, ' +
    'rozbicie kosztów i bezpłatne porównanie cen dla dużych domów z pompą ciepła i samochodem ' +
    'elektrycznym.',
  keywords: [
    'instalacja fotowoltaiczna 15 kWp cena',
    'panele słoneczne 15 kWp koszt',
    'ile kosztuje instalacja 15 kWp',
    '15 kWp instalacja fotowoltaiczna duży dom',
  ],
  eyebrow: 'Wielkość instalacji: 15 kWp',
  h1: 'Instalacja fotowoltaiczna 15 kWp: cena i wartości orientacyjne',
  intro:
    'Instalacja 15 kWp odpowiednia jest dla dużych domów jednorodzinnych lub dwurodzinnych z ' +
    'wysokim łącznym zużyciem, np. przez pompę ciepła i samochód elektryczny razem. Znajdziesz tu ' +
    'wartości orientacyjne dotyczące powierzchni dachu i liczby paneli, rozbicie kosztów, a tuż ' +
    'poniżej kalkulator z już wypełnioną średnią ceną dla 15 kWp, obliczoną na podstawie ' +
    'prawdziwych ofert firm rzemieślniczych.',
  calculatorPrefill: { kind: 'kwp', kwp: 15 },
  indexPolicy: 'index',
  sections: [
    { type: 'heading', text: 'Dla kogo odpowiednia jest instalacja 15 kWp?' },
    {
      type: 'paragraph',
      text:
        'Wartość orientacyjna: 15 kWp zwykle pasuje do dużego domu jednorodzinnego lub ' +
        'dwurodzinnego z pompą ciepła i samochodem elektrycznym, całkowite roczne zużycie często w ' +
        'przedziale 9 000-12 000 kWh. Przy dwóch niezależnych gospodarstwach w tym samym budynku ' +
        'warto dodatkowo skonsultować podział produkcji i zużycia energii.',
    },
    { type: 'heading', text: 'Dach i panele: czego potrzebuje instalacja 15 kWp' },
    {
      type: 'paragraph',
      text:
        `Wartość orientacyjna: ok. ${FACTS.roofAreaM2} m² powierzchni dachu i ok. ` +
        `${FACTS.moduleCount} paneli przy typowych modułach ~440 Wp. Roczna produkcja przy ` +
        `orientacji południowej bez zacienienia wynosi ok. ${FACTS.annualYieldKwh.toLocaleString('pl-PL')} kWh. ` +
        'Jeśli główna połać dachu nie wystarcza, firmy rzemieślnicze często rozważają rozłożenie ' +
        'paneli na kilka połaci o różnej orientacji - dokładne obliczenie dla Twojego dachu daje ' +
        'bezpłatny kalkulator doboru instalacji.',
    },
    { type: 'heading', text: 'Składniki kosztów instalacji fotowoltaicznej' },
    {
      type: 'list',
      items: [
        'Panele: największa pojedyncza pozycja kosztowa, zwykle około jednej trzeciej całości',
        'Falownik: przy 15 kWp zwykle trójfazowy, czasem z kilkoma stringami/falownikami',
        'Montaż/robocizna: mocowanie na dachu, okablowanie',
        'Rusztowanie: przy większej powierzchni dachu odpowiednio większe',
        'Instalacja elektryczna: dostosowanie rozdzielnicy, podłączenie do sieci domowej',
        'Zgłoszenie: rejestracja u operatora sieci i w odpowiednich rejestrach',
      ],
    },
    {
      type: 'paragraph',
      text:
        'Od ok. 15 kWp warto dokładniej sprawdzić konstrukcję dachu i wydolność przyłącza ' +
        'elektrycznego - oba aspekty ocenia firma rzemieślnicza na miejscu podczas przygotowywania ' +
        'oferty.',
    },
    { type: 'heading', text: 'Amortyzacja i autokonsumpcja' },
    {
      type: 'paragraph',
      text:
        'Z pompą ciepła i samochodem elektrycznym jako dodatkowymi odbiornikami można osiągnąć ' +
        'wysoki udział autokonsumpcji w instalacji 15 kWp, zwłaszcza gdy oba urządzenia pracują ' +
        'głównie w ciągu dnia. Dokładne obliczenie dla Twojego dachu daje bezpłatny kalkulator ' +
        'doboru instalacji.',
    },
  ],
  faq: [
    {
      q: 'Czy dla instalacji 15 kWp potrzebne jest pozwolenie na budowę?',
      a: 'Zwykle nie - instalacje fotowoltaiczne na istniejących dachach są w większości przypadków zwolnione z pozwolenia. Wyjątki dotyczą np. obiektów zabytkowych; w razie wątpliwości sprawdza to wcześniej firma rzemieślnicza.',
    },
    {
      q: 'Dla jakich budynków odpowiednia jest instalacja 15 kWp?',
      a: 'Typowo dla dużych domów jednorodzinnych lub dwurodzinnych z wysokim łącznym zużyciem, np. przez pompę ciepła i samochód elektryczny razem.',
    },
    {
      q: 'Jak wielkość instalacji wpływa na koszty montażu?',
      a: 'Większe instalacje, jak 15 kWp, mają zwykle nieco niższe koszty stałe w przeliczeniu na kWp (zgłoszenie, podstawowe rusztowanie) niż mniejsze instalacje, ponieważ te pozycje rozkładają się na większą zainstalowaną moc.',
    },
  ],
  primaryCta: { label: 'Poproś teraz o bezpłatną ofertę', action: 'customer' },
  secondaryCta: {
    label: 'Koszt instalacji fotowoltaicznej: pełny przewodnik',
    action: 'link',
    href: '/koszt-instalacji-fotowoltaicznej',
  },
  relatedLinks: [
    { label: 'Instalacja fotowoltaiczna 12 kWp: cena i wartości orientacyjne', href: '/instalacja-fotowoltaiczna-12-kwp-cena' },
    { label: 'Instalacja fotowoltaiczna 20 kWp: cena i wartości orientacyjne', href: '/instalacja-fotowoltaiczna-20-kwp-cena' },
    { label: 'Instalacja fotowoltaiczna 25 kWp: cena i wartości orientacyjne', href: '/instalacja-fotowoltaiczna-25-kwp-cena' },
    { label: 'Magazyn energii 15 kWh: cena i wartości orientacyjne', href: '/magazyn-energii-15-kwh-cena' },
    { label: 'Zaplanuj instalację krok po kroku', href: '/zaplanuj-instalacje-fotowoltaiczna' },
  ],
}
